import React from "react";
import Icon from "../../Icon";
import Tooltip from "../../Tooltip";
import { UploadModeButton, UploadModeLabel, UploadModeIconSide } from "./styles"

const UploadAudioButton = ({
    onClick,
    visible,
    onMouseEnter,
    onMouseLeave,
    disabled = false,
    disabledReason
}) => {
    const button = (
        <UploadModeButton
            type="button"
            onClick={disabled ? undefined : onClick}
            aria-label="Upload audio"
            aria-hidden={!visible}
            aria-disabled={disabled || undefined}
            tabIndex={visible && !disabled ? 0 : -1}
            $visible={visible}
            $disabled={disabled}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <UploadModeLabel>Upload Audio</UploadModeLabel>
            <UploadModeIconSide>
                <Icon type="upload" size={14} inheritColor />
            </UploadModeIconSide>
        </UploadModeButton>
    );

    if (disabled && disabledReason) {
        return <Tooltip title={disabledReason}>{button}</Tooltip>;
    }
    return button;
};

export default UploadAudioButton
